
// * ========================================================================
// * Responsive chart
// * ========================================================================

import storage from './storage';

const multiselectChart = (function(){

    function handleLegendClick(legend, chart, options) {
        // Get clicked dataset info
        const dataset = chart.data.datasets[legend.datasetIndex];
        const id = getDatasetId(dataset, options);

        const input = document.querySelector('[name="'+options.inputName+'"][value="'+id+'"]');

        if (legend.hidden) {
            // Select item
            input.checked = true;
        } else {
            // Unselect item
            input.checked = false;
        }

        handleSelectChange(chart, options);

        /*
        // Update max value
        let maxCount = 0;
        chart.data.datasets.forEach(function(dataset, i) {
            const meta = chart.getDatasetMeta(i);
            if (meta.hidden === null) {
                maxCount = (dataset.count * maxPadding) > maxCount ? dataset.count * maxPadding : maxCount;
            }
        });

        if (maxCount === 0) {
            maxCount = initialMax;
        }

        chart.options.scales.yAxes[0].ticks.suggestedMax = maxCount;

        chart.update();*/
    }

    function handleSelectChange(chart, options, isInit = false) {
        if (!(chart && chart.canvas)) {
            return;
        }

        const selectedValues = [];
        const selectedItems = [];
        const selectedInputs = document.querySelectorAll('input[name="'+options.inputName+'"]:checked');
        selectedInputs.forEach(function(input) {
            const inputValue = typeof options.valueType !== 'undefined' && options.valueType === 'integer' ? parseInt(input.value) : input.value;
            selectedValues.push(inputValue);
            selectedItems.push({
                name: input.getAttribute('data-name'),
                value: input.value
            });
        });

        const storageKey = chart.canvas.id + '_multiselect';
        storage.updateData(storageKey, selectedValues);

        if (!isInit && typeof options.reloadOnChange !== 'undefined' && options.reloadOnChange) {
            options.reloadOnChange(options.data, chart);
        } else {
            const selectedColors = [];
            chart.data.datasets.forEach(function(dataset, i) {
                const hiddenGuide = (typeof dataset.id !== 'undefined' && (dataset.id === 'hidden-guide' || dataset.id === 'always-visible')); // Hidden guide is always selected
                const meta = chart.getDatasetMeta(i);

                let isSelected = selectedValues.indexOf(dataset.id);

                // Speshul
                const selectAs = typeof dataset.multiselectShowFor !== 'undefined' ? dataset.multiselectShowFor : false;
                if (selectAs) {
                    isSelected = selectedValues.indexOf(selectAs);
                }

                const isForced = options.forceSelectedIds.indexOf(dataset.id);
                if (hiddenGuide || isSelected !== -1 || isForced !== -1) {
                    meta.hidden = null;
                    if (isSelected !== -1 && !selectAs) {
                        const dataSetColorLabel = dataset.name || selectedItems[isSelected].name;
                        const color = typeof options.colorField !== 'undefined' ? dataset[options.colorField] : 'borderColor';
                        if (typeof options.singleSelect !== 'undefined' && options.singleSelect) {
                            selectedColors.push('<button class="color color--no-input"><span class="color-box" style="background-color: '+color+'"></span> <span class="color-name">'+dataSetColorLabel+'</span></button>');
                        } else {
                            selectedColors.push('<button class="color color--with-remove '+options.inputName+'-color-label" title="Poista valinta" data-id="'+dataset.id+'"><span class="color-box" style="background-color: '+color+'"></span> <span class="color-name">'+dataSetColorLabel+'</span><span class="color-remove">x</span></button>');
                        }
                    }
                } else {
                    meta.hidden = true;
                }
            });

            // Show count
            if (options.countElemId) {
                const allInputs = document.querySelectorAll('input[name="'+options.inputName+'"]');
                document.getElementById(options.countElemId).innerHTML = selectedInputs.length + ' / '+allInputs.length;
            }

            // Update selected colors
            const colorElem = document.getElementById(options.colorElemId);
            if (colorElem) {
                colorElem.innerHTML = selectedColors.join('');
            }

            chart.update();
        }
    }

    function getDatasetId(item, options) {
        const id = typeof options.idField !== 'undefined' ? item[options.idField] : item.id;

        return id;
    }

    /**
     * Update chart options
     *
     * @param {Object} chart - chart instance
     * @param {Array} data - data
     * @param {Array} selectOptions - options
     */
    function create(chart, data, selectOptions = {}) {
        const options = selectOptions;
        if (typeof options.requireCount === 'undefined') {
            options.requireCount = false;
        }
        if (typeof options.sortData === 'undefined') {
            options.sortData = false;
        }
        if (typeof options.selectAll === 'undefined') {
            options.selectAll = false;
        }
        if (typeof options.forceSelectedIds === 'undefined') {
            options.forceSelectedIds = [];
        }

        // Datasets to create options
        const datasets = typeof options.multiselectOptions !== 'undefined' ? options.multiselectOptions : data;
        const secondaryDatasets = typeof options.secondaryMultiselectOptions !== 'undefined' ? options.secondaryMultiselectOptions : [];

        const createDatasetItem = function(item, checked) {
            let option = null;

            const hiddenGuide = (typeof item.id !== 'undefined' && (item.id === 'hidden-guide' || item.id === 'always-visible')) || (typeof item.multiselectHidden !== 'undefined' && item.multiselectHidden);
            if (!hiddenGuide && (!options.requireCount || item.count > 0)) {
                const id = getDatasetId(item, options);
                const selected = options.selectAll ? true : typeof item.selected !== 'undefined' ? item.selected : checked;
                const selectedAttr = selected ? ' checked' : '';
                const name = typeof item.name !== 'undefined' ? item.name : item.label;
                const inputType = typeof options.singleSelect !== 'undefined' && options.singleSelect ? 'radio' : 'checkbox';
                option = { name: name, markup: '<div class="multiselect-item"><label><input type="'+inputType+'" name="'+options.inputName+'" value="'+id+'"'+selectedAttr+' data-name="'+name+'"><span class="multiselect-item-name">'+name+'</span></label></div>' };
                checked = false;
            }

            return { option, checked };
        }

        // Create selects
        let items = [];
        let secondaryItems = [];
        let checked = true;

        for (let item of datasets) {
            const res = createDatasetItem(item, checked);
            if (res.option) {
                items.push(res.option);
            }
            checked = res.checked;
        }

        for (let item of secondaryDatasets) {
            const res = createDatasetItem(item, checked);
            if (res.option) {
                secondaryItems.push(res.option);
            }
            checked = res.checked;
        }

        if (options.sortData === 'name') {
            items.sort((a, b) => a.name.localeCompare(b.name));
            secondaryItems.sort((a, b) => a.name.localeCompare(b.name));
        }

        const selectMarkup = items.map(item => item.markup);
        document.getElementById(options.selectElemId).innerHTML = selectMarkup.join('');

        const sectionTitleClass = typeof options.sectionTitleClass !== 'undefined' ? options.sectionTitleClass : null;
        const sectionTitleElems = sectionTitleClass ? document.querySelectorAll('.'+sectionTitleClass) : null;

        if (typeof options.secondarySelectElemId !== 'undefined' && secondaryItems.length) {
            const sedondarySelectMarkup = secondaryItems.map(item => item.markup);
            document.getElementById(options.secondarySelectElemId).innerHTML = sedondarySelectMarkup.join('');

            if (sectionTitleElems) {
                sectionTitleElems.forEach((elem) => {
                    elem.style.display = 'block';
                });
            }
        } else if (sectionTitleElems) {
            sectionTitleElems.forEach((elem) => {
                elem.style.display = 'none';
            });
        }

        // Create event listener for select change
        const multiselectElements = document.querySelectorAll('input[name="'+options.inputName+'"]');
        multiselectElements.forEach((input) => {
            input.addEventListener('change', function (e) {
                handleSelectChange(chart, options);

                if (options.closeOnChange && options.dropdownId) {
                    document.getElementById(options.dropdownId).classList.remove('open');
                }

                if (typeof options.onChangeCallback === 'function') {
                    options.onChangeCallback();
                }
            });
        });

        handleSelectChange(chart, options, true);

        // Create click handler for colors
        document.addEventListener('click', function(event) {
            const color = event.target.closest('.'+options.inputName+'-color-label');
            if (color) {
                const id = color.getAttribute('data-id');
                document.querySelector('[name="'+options.inputName+'"][value="'+id+'"]').checked = false;
                handleSelectChange(chart, options);
            }
        });

        const selectAllElem = document.getElementById(options.selectAllElemId);
        if (selectAllElem) {
            selectAllElem.addEventListener('click', function(event) {
                event.preventDefault();
                event.stopPropagation();

                const inputs = document.querySelectorAll('[name="'+options.inputName+'"]');
                inputs.forEach(function(input) {
                    input.checked = true;
                });

                handleSelectChange(chart, options);
            });
        }

        const clearAllElem = document.getElementById(options.clearAllElemId);
        if (clearAllElem) {
            clearAllElem.addEventListener('click', function(event) {
                event.preventDefault();
                event.stopPropagation();

                const inputs = document.querySelectorAll('[name="'+options.inputName+'"]');
                inputs.forEach(function(input) {
                    input.checked = false;
                });
                handleSelectChange(chart, options);
            });
        }
    }

    /**
     * Update chart options
     *
     * @param {Array} data - data
     * @param {Array} options - options
     */
    function updateMultiselect(data = [], options = {}) {
        const colorElem = document.getElementById(options.colorElemId);
        if (colorElem) {
            const colors = colorElem.getElementsByClassName('color');
            for (let elem of colors) {
                for (let dataset of data) {
                    if (dataset.id === elem.getAttribute('data-id')) {
                        const colorName = elem.getElementsByClassName('color-name');
                        if (colorName.length) {
                            colorName[0].innerHTML = dataset.label;
                        }
                        break;
                    }
                }
            }
        }

        const inputs = document.querySelectorAll('input[name="'+options.inputName+'"]');
        inputs.forEach(function(elem) {
            for (let dataset of data) {
                if (dataset.id === elem.value) {
                    const colorName = elem.nextElementSibling;
                    if (colorName) {
                        colorName.innerHTML = dataset.label;
                        colorName.setAttribute('data-name', dataset.label);
                    }
                    break;
                }
            }
        });
    }

    return {
        create,
        legendClick: handleLegendClick,
        updateMultiselect
    }

})();

export default multiselectChart;
